import { render, staticRenderFns } from "./TaxWeightRequestResult.vue?vue&type=template&id=70ff81b6&scoped=true&"
import script from "./TaxWeightRequestResult.vue?vue&type=script&lang=ts&"
export * from "./TaxWeightRequestResult.vue?vue&type=script&lang=ts&"
import style0 from "./TaxWeightRequestResult.vue?vue&type=style&index=0&id=70ff81b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ff81b6",
  null
  
)

component.options.__file = "TaxWeightRequestResult.vue"
export default component.exports